import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../../../components/login/service/login.service';
import { HttpErrorResponse } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import { NotifierService } from 'angular-notifier';
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent {

  userDetails:any;
  dateTime:any=new Date();
   private readonly notifier: NotifierService;
  constructor(private route:ActivatedRoute,private service:LoginService,private router:Router,private notifierService: NotifierService,){
    this.notifier = this.notifierService;
  }
  ngOnInit(){
    //  let user = this.route.snapshot.data['userDetails'];
    //  console.log(user);
    if(!localStorage.getItem("user")){
       this.getUser();
    }
    
  }

    getUser(){
      this.service.getUser().subscribe({
        next:(response:any)=>{
          this.userDetails = response;
          var data = CryptoJS.AES.encrypt(JSON.stringify(response),this.service.enCryptKey);
            localStorage.setItem("user",data.toString());
         
          this.service.userDetails = response;
          if(!this.userDetails.hasOwnProperty("plan_id")){
            this.router.navigate(['/main/settings']);
            return;
          }
          if (new Date(this.userDetails?.end_date).getTime() < new Date(this.dateTime).getTime() && this.userDetails?.plan_id === 1) {
             this.router.navigate(['/main/settings']);
          } else {
             this.router.navigate(['/main/dashboard']);
          }
         
        },
        error:(error:HttpErrorResponse)=>{
        this.notifier.notify('error',error.error['message']);
        }
      });
    }

}
